module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAAZklEQVQ4T+2TwQ2AMAwDfZuwKYzACIzSEdjIqH0gCoioos9ayiOK5ES2gzqBLx7bq6Qd2KJ9EVGSlIBlEL0rYLtNI9tZzDkS9DoHKqNKY3uSlOuOYr+kh/1AvvbEsP9/svv8WkscDpgDQRA4eFONAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jia.png
// module id = dhU8
// module chunks = 1